// src/javascript/Utils/HMRManager.ts
import { autoInjectable, container } from 'tsyringe';
import VrScene from '../Components/Three/VrScene';
import Renderer from '../Components/Renderer';
import Camera from "../Camera";

@autoInjectable()
export default class HMRManager {
    private isReloading = false;

    public init(): void {
        if (typeof module === 'undefined' || !module.hot) {
            console.log('⚠️ HMR not available');
            return;
        }
        console.log('🔥 HMRManager initialized');
    }

    public async reloadCurrentScene(): Promise<void> {
        console.log('🔄 ========== RELOAD START ==========');

        if (this.isReloading) {
            console.warn('⏳ Already reloading');
            return;
        }

        this.isReloading = true;

        try {
            const renderer = container.resolve(Renderer);
            const currentScene = renderer.scene as VrScene;
            const roomInfo = VrScene.currentRoomInfo;

            if (!roomInfo) {
                console.warn('⚠️ No room info');
                this.isReloading = false;
                return;
            }

            // ✅ Załaduj nową klasę
            const SceneClass = await this.getLatestSceneClass(roomInfo.sceneName);
            if (!SceneClass) {
                this.isReloading = false;
                return;
            }

            // ✅ Stwórz nową scenę
            const newScene = container.resolve(SceneClass);

            // ✅ Zmień scenę normalnie - NIE RUSZAMY niczego innego
            //@ts-ignore
            await currentScene.changeScene(newScene, roomInfo.roomId, roomInfo.multiplayer, roomInfo.roomName);

            container.resolve(Camera).resetAfterHMR();


            console.log('✅ Done');
        } catch (error) {
            console.error('❌ Failed:', error);
        } finally {
            this.isReloading = false;
        }
    }

    private async getLatestSceneClass(sceneName: string): Promise<any> {
        const modules = {
            'Lobby': () => import('../Scenes/LobbyScene/LobbyScene'),
            'LobbyScene': () => import('../Scenes/LobbyScene/LobbyScene'),
            'PrivateRoom': () => import('../Scenes/PrivateRoom/PrivateRoomScene'),
            'SchoolLobby': () => import('../Scenes/SchoolLobby/SchoolLobby'),
            'Experiments': () => import('../Scenes/experiments/ExperimentsRoom'),
            'Group': () => import('../Scenes/Group/GroupScene'),
            'Classroom': () => import('../Scenes/Classroom/ClassroomScene'),
        };

        const loader = modules[sceneName];
        if (!loader) {
            console.error(`Unknown scene: ${sceneName}`);
            return null;
        }

        try {
            const module = await loader();
            return module.default;
        } catch (error) {
            console.error(`Import failed:`, error);
            return null;
        }
    }
}